<script setup>

</script>

<template>
    <v-card max-width="640" elevation="8" class="flex-fill my-10">
        <v-card-title>
            {{ pgettext('title', 'Device authentication successful') }}
        </v-card-title>
        <v-card-text>
            <v-alert type="success">
                {{ gettext('This device can now log automatically to MCIs.')}}
            </v-alert>
        </v-card-text>
        <v-card-actions>
            <v-btn :href="reverseUrl('web:account:login')" block>
                {{ pgettext('action', 'Go to login page') }}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>
